import styled from 'styled-components';

const StyledTile = styled.div`
  text-align: center;
  color: ${p => p.theme.carvana.blue.dark};
  width: 290px;
  margin: 12px 0;

  button {
    margin-top: 10px;
    border-radius: 3px;
    height: 40px;
    width: 261px;
  }
  img {
    margin-bottom: 14px;
  }
`;

export default StyledTile;
